module.exports = __webpack_public_path__ + "img/LOGO_DARK_MODE.ca198e3d.png";